import { Divider, DividerProps } from '@mui/material';
import { useTheme } from '../../hooks';

interface Props extends DividerProps {
    isWhite?: boolean;
}

export const DigitalhubDivider = ({ sx, isWhite, ...props }: Props) => {
    const { colors } = useTheme();
    return (
        <Divider
            flexItem
            {...props}
            sx={{ borderColor: isWhite ? colors.white : colors.primary, ...sx }}
        />
    );
};
